import React from 'react';
import DragLayer from 'react-dnd/lib/DragLayer';
import { Units } from 'Css';
import * as SvgIcons from 'components/Material/SvgIcons';

const css = oxygenCss({
  preview: {
    opacity: 0.8,
    top: 0,
    left: 0,
    position: 'absolute',
    backgroundColor: '#F0F0F0',
    textAlign: 'center',
    lineHeight: `${Units.keyline}px`,
    height: Units.keyline,
    boxSizing: 'border-box',
    display: 'block',
    width: `${Units.keyline * 1.5}px`,
    '>SVG': {
      verticalAlign: 'middle'
    }
  }
});

const styles = {
  icon: {
    width: Units.base * 4,
    height: Units.base * 4
  }
};

const icons = {
  Text: SvgIcons.EditorFormatAlignLeft,
  Banner: SvgIcons.ImageLandscape,
  Image: SvgIcons.ImageImage,
  Video: SvgIcons.AvMovie,
  List: SvgIcons.ImageViewComfy,
  Filter: SvgIcons.ContentFilterList
};

function collect(monitor) {
  const item = monitor.getItem();
  const initial = monitor.getInitialClientOffset();
  const difference = monitor.getDifferenceFromInitialOffset();
  return {
    id: item && item.id,
    type: item && item.type,
    initialClientOffset:
      initial && difference
        ? {
            x: initial.x + difference.x,
            y: initial.y + difference.y
          }
        : null,
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging()
  };
}

function getItemStyles(currentOffset) {
  if (!currentOffset) {
    return {
      display: 'none'
    };
  }
  const { x, y } = currentOffset;
  const transform = `translate(${x - 48}px, ${y - 96}px)`;

  return {
    pointerEvents: 'none',
    transform,
    WebkitTransform: transform
  };
}

class Preview extends React.Component {
  static propTypes = {
    id: React.PropTypes.string,
    type: React.PropTypes.string,
    currentOffset: React.PropTypes.shape({
      x: React.PropTypes.number,
      y: React.PropTypes.number
    }),
    initialClientOffset: React.PropTypes.shape({
      x: React.PropTypes.number,
      y: React.PropTypes.number
    }),
    isDragging: React.PropTypes.bool
  };

  render() {
    const { isDragging, type } = this.props;
    if (!isDragging) {
      return <div />;
    }
    const Icon = icons[this.props.type];
    return (
      <div
        className={css.preview}
        style={getItemStyles(this.props.initialClientOffset)}
      >
        <Icon style={styles.icon} className={css.icon} color={'#777777'} />
      </div>
    );
  }
}

export default DragLayer(collect)(Preview);



// WEBPACK FOOTER //
// ./src/js/components/Store/Editor/LayoutOverview/Preview.js